module.exports = __webpack_public_path__ + "img/educational-qualifications.29a237a6.svg";